<template>
  <Preference isMSDCustom :customCompanyId="customCompanyId" :surveyInfo="surveyInfo" :showOverlay="showOverlay"></Preference>
</template>

<script>
import { ROOT_COMPANY_ID } from '@/constant/company'
import Preference from '../preference/index.vue'

export default {
  components: {
    Preference
  },
  props: {
    surveyInfo: {
      type: Object,
      default: () => {}
    },
    showOverlay: {
      type: Boolean,
      required: true
    }
  },
  metaInfo () {
    return {
      title: '加入默沙东人才社区'
    }
  },
  data () {
    return {
      companyId: ROOT_COMPANY_ID.MSD
    }
  },
  computed: {
    customCompanyId () {
      if (this.$route.meta?.customCompanyId) {
        return this.$route.meta?.customCompanyId
      }
      return this.companyId
    }
  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
</style>
